/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { NoserMemberDetailDto } from './noserMemberDetailDto.schema';

export const SyncMemberDetails = zod.object({
  "payload": zod.array(zod.lazy(() => NoserMemberDetailDto)).optional()
});

export type SyncMemberDetails = zod.input<typeof SyncMemberDetails>;
export type SyncMemberDetailsOutput = zod.output<typeof SyncMemberDetails>;
